import React from 'react';

interface WhiskeyLogoProps {
  size?: number;
  className?: string;
}

/**
 * The Whiskey mascot mark (a Goldendoodle) — fur always renders in
 * --ember/--ember-strong regardless of background. Matches the SVG used
 * throughout the mockups (docs/build-plan) so this is a 1:1 port, not a
 * reinterpretation.
 */
const WhiskeyLogo: React.FC<WhiskeyLogoProps> = ({ size = 18, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className}>
    <path d="M6.5 8C3 9.2 2.3 14.5 4.5 18 6.6 16.3 7.6 11 6.5 8Z" fill="var(--ember-strong)" />
    <path d="M17.5 8C21 9.2 21.7 14.5 19.5 18 17.4 16.3 16.4 11 17.5 8Z" fill="var(--ember-strong)" />
    <circle cx="12" cy="11.5" r="6.6" fill="var(--ember)" />
    <circle cx="8.7" cy="5.6" r="1.5" fill="var(--ember)" />
    <circle cx="12" cy="4.6" r="1.7" fill="var(--ember)" />
    <circle cx="15.3" cy="5.6" r="1.5" fill="var(--ember)" />
    <circle cx="9.3" cy="11" r="0.95" fill="var(--ink)" />
    <circle cx="14.7" cy="11" r="0.95" fill="var(--ink)" />
    <ellipse cx="12" cy="13.7" rx="1.25" ry="0.95" fill="var(--ink)" />
  </svg>
);

export default WhiskeyLogo;
